import { render, staticRenderFns } from "./UsersHeaderComponent.vue?vue&type=template&id=387b0f7a&"
import script from "./UsersHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./UsersHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports